import * as actions from './actionTypes';

export function getClaims() {
  return { type: actions.GET_CLAIMS };
}

export function getClaimsSuccess(claims) {
  return { type: actions.GET_CLAIMS_SUCCESS, payload: { claims } };
}

export function getClaimsFailed(error) {
  return { type: actions.GET_CLAIMS_FAILED, payload: { error } };
}

export function getGWClaims() {
  return { type: actions.GET_GW_CLAIMS };
}

export function getGWClaimsSuccess(gwClaims) {
  return { type: actions.GET_GW_CLAIMS_SUCCESS, payload: { gwClaims } };
}

export function getGWClaimsFailed(error) {
  return { type: actions.GET_GW_CLAIMS_FAILED, payload: { error } };
}

export function createClaim(lang) {
  return { type: actions.CREATE_CLAIM, lang };
}

export function createClaimSuccess(createdClaim) {
  return { type: actions.CREATE_CLAIM_SUCCESS, payload: { createdClaim } };
}

export function createClaimFailed(error) {
  return { type: actions.CREATE_CLAIM_FAILED, payload: { error } };
}

export function updateClaim(claimId, status, submissionData, submissionDataGW, isUpdateToGwRequired, lang, metadata, lossDetailsConfirmed, leaveForm) {
  return { type: actions.UPDATE_CLAIM, payload: { claimId, status, submissionData, submissionDataGW, isUpdateToGwRequired, lang, metadata, lossDetailsConfirmed, leaveForm } };
}

export function updateClaimSuccess(submittedData) {
  return { type: actions.UPDATE_CLAIM_SUCCESS, payload: submittedData };
}

export function updateClaimFailed(error) {
  return { type: actions.UPDATE_CLAIM_FAILED, payload: { error } };
}

export function createShellClaim(draftClaimId, policyNumber, dateOfLoss, sourceSystem, preferredLanguage, vehiclePolicySystemId, dwellingPolicySystemId) {
  return { type: actions.CREATE_SHELL_CLAIM, payload: { draftClaimId, policyNumber, dateOfLoss, sourceSystem, preferredLanguage, vehiclePolicySystemId, dwellingPolicySystemId } };
}

export function createShellClaimSuccess(claimId, gwClaimId, gwClaimNumber, policyAddress) {
  return { type: actions.CREATE_SHELL_CLAIM_SUCCESS, payload: { claimId, gwClaimId, gwClaimNumber, policyAddress } };
}

export function createShellClaimFailed(error) {
  return { type: actions.CREATE_SHELL_CLAIM_FAILED, payload: { error } };
}

export function createShellClaimDuplicated() {
  return { type: actions.CREATE_SHELL_CLAIM_DUPLICATED };
}

export function submitClaim(claimId) {
  return { type: actions.SUBMIT_CLAIM, payload: { claimId } };
}

export function submitClaimSuccess(submittedData) {
  return { type: actions.SUBMIT_CLAIM_SUCCESS, payload: submittedData };
}

export function submitClaimFailed(error) {
  return { type: actions.SUBMIT_CLAIM_FAILED, payload: { error } };
}

export function clearClaimsErrors() {
  return { type: actions.CLEAR_ERRORS };
}

export function clearShellClaimDuplicated() {
  return { type: actions.CLEAR_SHELL_CLAIM_DUPLICATED };
}
